import React from 'react';
import logo from '../assets/img/logo.png';

const LogoLettering = () => (
    <div className="LogoLettering">
        <h1>Y</h1>
        <h1>C</h1>
        <img src={logo} />
        <h1>F</h1>
        <h1>C</h1>
    </div>
);

export default LogoLettering;



// WEBPACK FOOTER //
// ./src/components/LogoLettering.js